module.exports = __webpack_public_path__ + "media/components/t-shirt-comp/static/Playade-Patos-af8be7c1c3ff1d0f97273fcebb50dff2.jpg";